import React, { useState } from 'react'
import { withStyles, makeStyles } from '@material-ui/core/styles'

import { Menu, Icon, Button } from '@material-ui/core'

const StyledMenu = withStyles({
	paper: {
		borderRadius: 6,
		minWidth: 280,
		boxShadow: '0px 2px 15px rgba(26, 26, 53, 0.2)'
	}
})((props) => (
	<Menu
		elevation={0}
		getContentAnchorEl={null}
		anchorOrigin={{
			vertical: 'bottom',
			horizontal: 'right'
		}}
		transformOrigin={{
			vertical: 'top',
			horizontal: 'right'
		}}
		{...props}
	/>
))

const useStyles = makeStyles((theme) => ({
	dots: {
		height: 38,
		width: 38,
		padding: 0,
		'& :before': {
			fontSize: '22px'
		}
	}
}))

const EditVisitDropdown = (props) => {
	const classes = useStyles()
	const [anchorEl, setAnchorEl] = useState(null)

	const handleClick = (event) => {
		setAnchorEl(event.currentTarget)
	}

	const handleClose = () => {
		setAnchorEl(null)
	}

	return (
		<div>
			<Button
				variant="outlined"
				color="secondary"
				endIcon={<i className="fa fa-caret-down" />}
				onClick={(e) => handleClick(e)}>
				Actions
			</Button>
			<StyledMenu
				id="customized-menu"
				anchorEl={anchorEl}
				keepMounted
				open={Boolean(anchorEl)}
				onClose={handleClose}>
				{props.children}
			</StyledMenu>
		</div>
	)
}

export default EditVisitDropdown
